import React, { Component } from 'react'
import { Batch } from './NewOrder';
import moment from "moment";
import $ from 'jquery';
class BatchDefinitionModal extends Component {

    componentDidMount = () =>{
        this.closeAction();
    }
    closeAction = () => {
        const { cleanData } = this.props;
        $('#batchDefinitionModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    SelectItem = async(lineNum) => {
        const {newOrderModel, refreshModel} = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.ItemBatchSelected = true;
            }else{
                item.ItemBatchSelected = false;
            }
        }

        await refreshModel(newOrderModel);
    }

    AddBatch = async (lineNum) => {
        const {newOrderModel, refreshModel, showAlert} = this.props;
        let today = moment(new Date()).format('YYYY-MM-DD');
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                let batch = new Batch();
                batch.BatchNumber = `L${item.BatchNumbers.length+1}`
                batch.BaseLineNumber = lineNum;
                batch.ExpiryDate = today;
                batch.ManufacturingDate = today;
                batch.AddmisionDate = today;
                batch.Quantity = Number(item.DocUoMQty - item.SnBUoMQty);
                item.BatchNumbers.push(batch);

                item.SnBUoMQty = 0;
                for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                    const batch = item.BatchNumbers[indez];
                    item.SnBUoMQty+= Number(batch.Quantity);
                }

                if (item.SnBUoMQty > item.DocUoMQty ){
                    showAlert({ type: 'warning', message: `Cantidad excedida`, timeOut: 8000 });
                    return;
                }
            }
        }

        await refreshModel(newOrderModel);
    }

    DeleteBatch = async (lineNum, indexBatch) => {
        const {newOrderModel, refreshModel} = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.BatchNumbers.splice(indexBatch,1);
                item.SnBUoMQty = 0;
                for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                    const batch = item.BatchNumbers[indez];
                    item.SnBUoMQty+= Number(batch.Quantity);
                }
            }
        }

        await refreshModel(newOrderModel);
    }
    
    ChangeBatchNumber = async (value, lineNum, indexBatch) => {
        const {newOrderModel, refreshModel} = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.BatchNumbers[indexBatch].BatchNumber = value;
            }
        }
        await refreshModel(newOrderModel);
    }

    ChangeQuantity = async (value, lineNum, indexBatch) => {
        const {newOrderModel, refreshModel, showAlert} = this.props;
        if (isNaN(value)) {
            return showAlert({ type: 'warning', message: `Cantidad invalida`, timeOut: 8000 });;
        }
        if (value < 0) {
            return showAlert({ type: 'warning', message: `Cantidad invalida`, timeOut: 8000 });;
        }

        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.BatchNumbers[indexBatch].Quantity = value;
                item.SnBUoMQty = 0;
                for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                    const batch = item.BatchNumbers[indez];
                    item.SnBUoMQty+= Number(batch.Quantity);
                }
                if(item.SnBUoMQty > item.DocUoMQty){
                    showAlert({ type: 'warning', message: `Cantidad excedida`, timeOut: 8000 });
                    return;
                }
            }
        }
        
        await refreshModel(newOrderModel);
    }

    ChangeManufacturerSerialNumber = async (value, lineNum, indexBatch) => {
        const {newOrderModel, refreshModel} = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.BatchNumbers[indexBatch].ManufacturerSerialNumber = value;
            }
        }
        await refreshModel(newOrderModel);
    }

    ChangeInternalSerialNumber = async (value, lineNum, indexBatch) => {
        const {newOrderModel, refreshModel} = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.BatchNumbers[indexBatch].InternalSerialNumber = value;
            }
        }
        await refreshModel(newOrderModel);
    }

    ChangeExpiryDate = async (value, lineNum, indexBatch) => {
        const {newOrderModel, refreshModel} = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.BatchNumbers[indexBatch].ExpiryDate = value;
            }
        }
        await refreshModel(newOrderModel);
    }

    ChangeManufacturingDate = async (value, lineNum, indexBatch) => {
        const {newOrderModel, refreshModel} = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.BatchNumbers[indexBatch].ManufacturingDate = value;
            }
        }
        await refreshModel(newOrderModel);
    }

    ChangeAddmisionDate = async (value, lineNum, indexBatch) => {
        const {newOrderModel, refreshModel} = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.BatchNumbers[indexBatch].AddmisionDate = value;
            }
        }
        await refreshModel(newOrderModel);
    }

    ChangeLocation = async (value, lineNum, indexBatch) => {
        const {newOrderModel, refreshModel} = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.BatchNumbers[indexBatch].Location = value;
            }
        }
        await refreshModel(newOrderModel);
    }

    ChangeNotes = async (value, lineNum, indexBatch) => {
        const {newOrderModel, refreshModel} = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.BatchNumbers[indexBatch].Notes = value;
            }
        }
        await refreshModel(newOrderModel);
    }

    Cancel = async (lineNum) => {
        const {newOrderModel, refreshModel} = this.props;
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            if (item.LineNum === lineNum) {
                item.BatchNumbers = [];
                item.SnBUoMQty = 0;
            }
        }
        await refreshModel(newOrderModel);
        $('#batchDefinitionModal').modal('hide');
    }

    Continue = (option) => {
        if (option===true) {
            $('#batchDefinitionModal').modal('hide');
            $('#continueBatchModal').modal('hide');
        }else{
            $('#continueBatchModal').modal('hide');
        }
        
    }


    render() {
        const {newOrderModel} = this.props;
        let items = newOrderModel.Items || [];
        let itemSelected = items.find((item) => item.ItemBatchSelected === true);
        
        if(!itemSelected){
            let itemsBatch = items.filter((item)=>item.ManBtchNum === 'Y');
            itemSelected = itemsBatch[0];
        }
        return (
            <>
            <div className="modal fade" id="batchDefinitionModal" data-keyboard="false" tabIndex="-1" aria-labelledby="batchDefinitionModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343A40" }}>
                            <h5 style={{color: "white"}}>Definición de lotes</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-12 p-4'>
                                    <h6><strong>Lineas del documento: </strong></h6>
                                    <div style={{ border: "1px solid #00000020", height: "25vh", overflowY: "scroll" }}>
                                        <table className="table response table-hover table-striped" style={{ marginBottom: 0 }}>
                                            <thead className='sticky-header' style={{ background:'white' }}>
                                                <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">No. Documento</th>
                                                    <th scope="col">Artículo</th>
                                                    <th scope="col">Descripción</th>
                                                    <th className="text-center" scope="col">Almacén</th>
                                                    <th scope="col">Necesario</th>
                                                    <th scope="col">Total creado</th>
                                                </tr>
                                            </thead>
                                               {this.RenderItemsBatch()}
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12 p-4'>
                                    <h6><strong>Lotes creados: </strong></h6>
                                    <div style={{ border: "1px solid #00000020", height: "30vh", overflowY: "scroll" }}>
                                        <table className="table response table-hover table-striped" style={{ marginBottom: 0 }}>
                                            <thead className='sticky-header' style={{ background:'white' }}>
                                                <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col" style={{minWidth:"120px"}}>Lote</th>
                                                    <th scope="col">Cantidad</th>
                                                    <th scope="col">Atributo</th>
                                                    <th scope="col">Atributo 2</th>
                                                    <th scope="col">F. Vencimiento</th>
                                                    <th scope="col">F. Fabricación</th>
                                                    <th scope="col">F. Admisión</th>
                                                    <th scope="col">Localidad</th>
                                                    <th scope="col">Info.Detallada</th>  
                                                    <th scope="col"></th>                                                 
                                                    
                                                </tr>
                                            </thead>
                                            {this.RenderBatch()}
                                        </table>
                                    </div>
                                </div>
                            </div>
                            {this.RenderBatchFooter()}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCorrect mr-4" onClick={()=>this.Cancel(itemSelected.LineNum)}>Cancelar</button>
                            {this.RenderContinue()}
                        </div>
                    </div>
                </div>
                
            </div>
            {this.renderValidation()}
            </>
        )
    }




    RenderItemsBatch = () => {
        const {newOrderModel} = this.props;
        let items = newOrderModel.Items || [];
        let itemsBatch = items.filter((item)=>item.ManBtchNum === 'Y');
        return(
            <tbody style={{ fontSize:'14px' }}>
                {itemsBatch.length > 0 &&
                    itemsBatch.map((item, index)=>{
                        return(
                            <tr style={{background:`${item.ItemBatchSelected ? '#FFF8D2':'white'}`}} onClick={()=>this.SelectItem(item.LineNum)}>
                                <td>{index+1}</td>
                                <td>EB1</td>
                                <td>{item.ItemCode || ''}</td>
                                <td>{item.ItemName || ''}</td>
                                <td>{item.WhsCode || ''}</td>
                                <td>{item.DocUoMQty || 0}</td>
                                <td>{item.SnBUoMQty || 0}</td>
                            </tr>
                        )
                    })
                }
                
            </tbody>
        );
    }

    RenderBatch = () => {
        const {newOrderModel} = this.props;
        let items = newOrderModel.Items || [];
        let itemSelected = items.find((item) => item.ItemBatchSelected === true);
        
        if(!itemSelected){
            let itemsBatch = items.filter((item)=>item.ManBtchNum === 'Y');
            itemSelected = itemsBatch[0];
        }
        let isEmptyBatch = itemSelected.BatchNumbers.filter((batch) => Number(batch.Quantity) === 0)
        let showAddIcon =  isEmptyBatch.length > 0 ? false : true;
        return(
            <tbody>
                {itemSelected.BatchNumbers.length > 0 &&
                    itemSelected.BatchNumbers.map((batch, index)=>{
                            
                            return(
                                    <tr>
                                        {/* # */}
                                        <td>{index+1}</td>
                                        {/* LOTE */}
                                        <td>
                                            <input type="text" className="form-control"
                                                value={batch.BatchNumber || ''} 
                                                onChange={(event)=>this.ChangeBatchNumber(event.target.value, itemSelected.LineNum, index)}/>
                                        </td>
                                        {/* CANTIDAD */}
                                        <td>
                                            <input type="text" className="form-control"
                                                value={batch.Quantity || ''}
                                                onChange={(event)=>this.ChangeQuantity(event.target.value, itemSelected.LineNum, index)}/>
                                        </td>
                                        {/* ATRIBUTO 1 */}
                                        <td>
                                            <input type="text" className="form-control"
                                                value={batch.ManufacturerSerialNumber || ''}
                                                onChange={(event)=>this.ChangeManufacturerSerialNumber(event.target.value, itemSelected.LineNum, index)}/>
                                        </td>
                                        {/* ATRIBUTO 2 */}
                                        <td>
                                            <input type="text" className="form-control"
                                                value={batch.InternalSerialNumber || ''}
                                                onChange={(event)=>this.ChangeInternalSerialNumber(event.target.value, itemSelected.LineNum, index)}/>
                                        </td>
                                        {/* F. VENCIMIENTO */}
                                        <td>
                                            <input type="date" className="form-control"
                                                min="2000-01-01"
                                                max='9999-12-31'
                                                value={batch.ExpiryDate || ''}
                                                onChange={(event)=>this.ChangeExpiryDate(event.target.value, itemSelected.LineNum, index)}/>
                                        </td>
                                        {/* F.FABRICACIÓN */}
                                        <td>
                                            <input type="date" className="form-control"
                                                min="2000-01-01"
                                                max='9999-12-31'
                                                value={batch.ManufacturingDate || ''}
                                                onChange={(event)=>this.ChangeManufacturingDate(event.target.value, itemSelected.LineNum, index)}/>
                                        </td>
                                        {/* F. ADMISIÓN */}
                                        <td>
                                            <input type="date" className="form-control"
                                                 min="2000-01-01"
                                                 max='9999-12-31'
                                                value={batch.AddmisionDate || ''}
                                                onChange={(event)=>this.ChangeAddmisionDate(event.target.value, itemSelected.LineNum, index)}/>
                                        </td>
                                        {/* LOCALIDAD */}
                                        <td>
                                            <input type="text" className="form-control"
                                                value={batch.Location || ''}
                                                onChange={(event)=>this.ChangeLocation(event.target.value, itemSelected.LineNum, index)}/>
                                        </td>
                                        {/* INFO. DETALLADA */}
                                        <td>
                                            <input type="text" className="form-control"
                                                value={batch.Notes || ''}
                                                onChange={(event)=>this.ChangeNotes(event.target.value, itemSelected.LineNum, index)}/>
                                        </td>
                                        <td style={{textAlign: 'center' }}>
                                            {/*Eliminar*/}
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    padding: 5,
                                                    color: '#c42222',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                }}
                                                className="btn"
                                                onClick={() => this.DeleteBatch(itemSelected.LineNum, index)}>
                                                <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                            </button>
                                        </td>
                                    </tr>
                            )
                        })
                }

                {showAddIcon && itemSelected.SnBUoMQty < itemSelected.DocUoMQty && 
                    <tr>
                        <td></td>
                        <td colSpan={2}>
                            <button type="button" className="btn btn-outline-secondary"
                                onClick={()=>this.AddBatch(itemSelected.LineNum)}>
                                <i className="fa fa-plus " aria-hidden="true"/>
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
        );
    }

    RenderBatchFooter = () => {
        const {newOrderModel} = this.props;
        let items = newOrderModel.Items || [];
        let itemSelected = items.find((item) => item.ItemBatchSelected === true);
        
        if(!itemSelected){
            let itemsBatch = items.filter((item)=>item.ManBtchNum === 'Y');
            itemSelected = itemsBatch[0];
        }
        return(
            <>
                <div className='row'>
                    <div className='col-3 pl-4'>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="">Lotes creados:</span>
                            </div>
                            <input type="text" disabled="true" className="form-control" value={itemSelected.BatchNumbers.length || ''}/>
                        </div>
                    </div>
                    <div className='col-3'>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="">Ctd. creada:</span>
                            </div>
                            <input type="text" disabled="true" className="form-control" value={itemSelected.SnBUoMQty || ''}/>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-1'></div>
                    <div className='col-4 mt-4'>
                        {/* <button type="button" className="btn botonCorrect mr-4" onClick={()=>this.Cancel(itemSelected.LineNum)}>Cancelar</button>
                        {this.RenderContinue()} */}
                    </div>
                    <div className='col-7'>

                    </div>
                </div>
                
            </>
        )
    }

    RenderContinue = () => {
        const {newOrderModel} = this.props;
        let showContinue = false;
        let items = newOrderModel.Items || [];
        let itemsBatch = items.filter((item)=>item.ManBtchNum === 'Y');
        for (let index = 0; index < itemsBatch.length; index++) {
            const item = itemsBatch[index];
            item.SnBUoMQty = 0;
            for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                const batch = item.BatchNumbers[indez];
                item.SnBUoMQty+= Number(batch.Quantity);
            }
            if(item.SnBUoMQty <= item.DocUoMQty && item.SnBUoMQty !== 0){
                showContinue = true;
            }
        }

        return(
            <>
                {showContinue && <button type="button" className="btn botonCorrect" data-toggle="modal" data-target="#continueBatchModal">Continuar</button>}
            </>
        )
    }

    renderValidation() {
       
        return (
            <div className="modal" tabIndex="-1" role="dialog" id="continueBatchModal" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                    <div className="modal-body">
                        <p>¿Deseas continuar?</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn botonCerrar text-white" onClick={()=>this.Continue(true)}> Si </button>
                        <button type="button" className="btn botonCorrect text-black"  onClick={()=>this.Continue(false)}>No</button>
                    </div>
                    </div>
                </div>
            </div>
        );  
    }
}


export default BatchDefinitionModal
